var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-selector"},[_c('tree-view',{staticClass:"map-selector",attrs:{"model":_vm.filters,"category":"children","display":_vm.type === 'Networks' ? _vm.display : '',"selection":_vm.value,"onSelect":_vm.onSelect,"strategies":_vm.strategies,"transition":_vm.transition}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }